<template>
  <transition
    enter-active-class="transition-all duration-100 ease-out"
    leave-active-class="transition-all duration-100 ease-in"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
    @after-enter="reveal"
  >
    <div
      class="absolute inset-0 overflow-hidden bg-gray-500 bg-opacity-75 flex"
      @click="backdropClick"
    >
      <div
        class="fixed inset-y-0 xl:relative transform flex-none z-30 h-screen duration-100 transition-transform"
        :class="[asideVisible ? 'translate-x-0' : '-translate-x-full xl:translate-x-0']"
        @click.stop
      >
        <transition
          enter-active-class="transition-all duration-100 ease-out transform"
          leave-active-class="transition-all duration-100 ease-in transform"
          enter-class="opacity-0 -translate-x-full"
          enter-to-class="opacity-100 translate-x-0"
          :leave-class="leaveClass"
          leave-to-class="opacity-0 -translate-x-full"
          @after-leave="$emit('modal:aside-hidden')"
        >
          <slot v-if="visible" name="aside" />
        </transition>
      </div>
      <!-- Aside -->

      <div
        class="absolute xl:hidden inset-0 overflow-hidden bg-gray-500 bg-opacity-75 flex z-20 duration-100 transition-all"
        :class="[asideVisible ? 'xl:hidden' : 'hidden']"
        @click.stop="asideVisible = !asideVisible"
      />
      <!-- Aside backdrop -->

      <div class="flex-1 z-10 flex items-start justify-center overflow-auto p-4 lg:p-12">
        <transition
          enter-active-class="transition-all duration-100 ease-out transform"
          leave-active-class="transition-all duration-100 ease-in transform"
          enter-class="opacity-0 translate-y-48"
          enter-to-class="opacity-100 translate-y-0"
          leave-class="opacity-100 translate-y-0"
          leave-to-class="opacity-0 translate-y-48"
          @after-leave="hideModal"
        >
          <slot v-if="visible" />
        </transition>
      </div>
    </div>
    <!-- Backdrop A -->
  </transition>
</template>

<script>
export default {
  name: 'VModalWithAside',

  props: {
    disableBackdropClick: Boolean,
    onModalHide: {
      type: Function,
      default: undefined,
    },
  },

  data() {
    return {
      visible: false,
      asideVisible: true,
    };
  },

  computed: {
    leaveClass() {
      if (this.asideVisible) {
        return 'opacity-100 translate-x-0';
      }

      return 'opacity-100 -translate-x-full';
    },
  },

  mounted() {
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    const windowWidth = window.innerWidth;
    const bodyWidth = body.offsetWidth;
    const htmlScrollHeight = html.scrollHeight;
    const htmlClientHeight = html.clientHeight;

    body.classList.add('overflow-hidden');

    if (htmlScrollHeight > htmlClientHeight) {
      body.style.marginRight = `${windowWidth - bodyWidth}px`;
    }

    this.$emit('modal:mounted');
    this.reveal();
  },

  destroyed() {
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    const htmlScrollHeight = html.scrollHeight;
    const htmlClientHeight = html.clientHeight;

    body.classList.remove('overflow-hidden');

    if (htmlScrollHeight > htmlClientHeight) {
      body.style.marginRight = null;
    }

    this.$emit('modal:destroyed');
  },

  methods: {
    hideModal() {
      this.$emit('modal:hidden');

      if (typeof this.onModalHide === 'function') {
        this.onModalHide();
      }
    },
    reveal() {
      this.visible = true;
    },
    backdropClick() {
      if (this.disableBackdropClick) {
        return;
      }
      this.close();
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
